/**
 * How many rows the current filters matched, in a sentence that agrees with it.
 *
 * The count and its wording travel together because they disagreed once the
 * filters made a single-row result ordinary: "1 observed roles match" is what a
 * narrowed jobs view showed, and the timeline had already grown its own inline
 * ternary to avoid the same thing. Three views state this, so the agreement is
 * stated once.
 *
 * Both phrasings are given by the caller rather than derived. English plurals
 * are not a suffix rule -- "company matches" against "companies match" changes
 * the noun and the verb -- and guessing them in a component is how a view ends
 * up reading "1 companys matches".
 */
export function ResultSummary({ count, one, many }: { count: number; one: string; many: string }) {
  return (
    <div className="result-summary">
      <strong>{count}</strong> {count === 1 ? one : many}
    </div>
  );
}
